(function() {
'use strict';

angular
    .module('core')
    .directive('comboboxMkc', comboboxMkc);

function comboboxMkc() {
    return {
        restrict: 'E',
        link: _linker,
        require: '^combobox'
    };

    function _linker(scope, el, attr, combobox) {
        const parentElement = combobox.element;
        const searchField = parentElement.find('input');
        const list = parentElement.find('ul');
        const pScope = scope.$parent;
        const keyBehaviours = {};

        searchField.on('keydown.combo', function keySelector(e) {
            const fn = keyBehaviours[e.keyCode] || angular.noop;
            fn(e);
        });

        list.on('mouseenter.combo', 'li', function selectItem() {
            $(this).addClass('combobox-selected');
        });

        list.on('mouseleave.combo', 'li', function selectItem() {
            $('.menu-list li').removeClass('combobox-selected');
        });

        scope.$on('$destroy', () => {
            searchField.off('keydown.combo');
            list.off('mouseenter.combo');
            list.off('mouseleave.combo');
        });

        keyBehaviours[9] = function tab() {
            list.hide();
        };

        // Return
        keyBehaviours[13] = function keyboardSelection() {
            pScope.clickHandler(_getScopeFromElement());
        };

        // Up arrow
        keyBehaviours[38] = _keyboardMovement(true);

        // Down arrow
        keyBehaviours[40] = _keyboardMovement();

        // Escape
        keyBehaviours[27] = function hideMenu() {
            pScope.menu = false;
            scope.$apply();
        };

        function _getScopeFromElement() {
            const se = $('.combobox-selected').scope();
            return se.d || {};
        }

        function _scrollOffset(sel) {
            const selHeight = sel.outerHeight();
            const elementTop = sel.offset() ? sel.offset().top : 0;
            const elementBottom = elementTop + selHeight;
            const listTop = list.offset() ? list.offset().top : 0;
            const listBottom = listTop + list.innerHeight();

            switch (true) {
                case (listTop >= elementTop):
                    return -selHeight;
                case (listBottom <= elementBottom):
                    return selHeight;
                default:
                    return 0;
            }
        }

        /* direction === true -> UP
           direction == false -> DOWN */
        function _keyboardMovement(direction) {
            return () => {
                let current = list.find('.combobox-selected');

                current.removeClass('combobox-selected');
                current = direction ? current.prev() : current.next();
                list[0].scrollTop += _scrollOffset(current);

                if (!current.length) {
                    const elements = list.find('li');
                    const index = direction ? elements.length - 1 : 0;
                    current = $(elements[index]);
                    list[0].scrollTop = direction ? list[0].scrollHeight : 0;
                }
                current.addClass('combobox-selected');
            };
        }
    }
}
})();
